import * as Yup from 'yup';
import { Formik } from 'formik';
import React, { Fragment } from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { JobPositionDropdown } from 'components/layout/form-fields/inputs/JobPositionDropdown';
import { jobPositionStore } from 'ats/pages/job-positions/JobPositionStore';
import { notificationStore } from 'components/layout/notifications/NotificationStore';
import { dialogStore } from 'components/layout/modals/DialogStore';

const ValidationSchema = Yup.object().shape({
	job: Yup.object().required().label('Job Position')
});

export class AssignToJobModal extends ModalComponent {
	getInitialValues() {
		return {
			job: null
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.create(values);
				}}>
				{formikBag => this.renderModalContainer(formikBag, 'AssignToJobModal')}
			</Formik>
		);
	}

	renderForm(formikBag) {
		const { applicantIds } = this.props;
		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<p className="mb-4">
							Assigning {applicantIds?.length || 0} candidate(s) to a job
							position.
						</p>
						<div className="field has-text-left">
							<label className="subtitle is-7">Job Position</label>
							<div className="control">
								<JobPositionDropdown
									onValueChange={item => {
										formikBag.setFieldValue('job', item);
									}}
									value={formikBag.values.job}
									showOnlyOpenJobs
								/>
							</div>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}

	async create(values) {
		const { applicantIds, onSuccess } = this.props;

		try {
			const result = await jobPositionStore.addApplicants(values.job.id, {
				applicantIds: applicantIds
			});

			if (result.status === 'success') {
				if (result.skippedApplicants && result.skippedApplicants.length > 0) {
					const addedCount = result.data.length;
					const skippedNames = result.skippedApplicants
						.map(a => a.name)
						.join(', ');

					let message;
					if (addedCount === 0) {
						message =
							result.message ||
							'All selected Candidates are already associated with this Job Position.';
						this.saving(false);
					} else {
						message = `${addedCount} candidate(s) added successfully.
						The following candidates were not added as they are already associated with this Job Position:
						${skippedNames}.`;
						this.closeWithSuccess(result);
					}

					dialogStore.openDialog(
						{
							title: 'Candidates Assigned',
							message: message,
							confirmLabel: 'OK',
							hideCancelButton: true
						},
						() => {
							if (onSuccess) {
								onSuccess();
							}
						}
					);
				} else {
					const message = `Successfully assigned ${applicantIds.length} candidate(s) to ${values.job.title}`;

					notificationStore.pushNotification({
						type: notificationStore.SUCCESS_NOTIFICATION,
						title: 'Candidates Assigned',
						message: message
					});

					this.closeWithSuccess(result);

					if (onSuccess) {
						onSuccess();
					}
				}
			} else {
				const errorMessage =
					result.message || 'Failed to assign candidates to job';
				notificationStore.pushNotification({
					type: notificationStore.ERROR_NOTIFICATION,
					title: 'Assignment Failed',
					message: errorMessage
				});
				// Unblock submit button so user can retry
				this.saving(false);
			}
		} catch (error) {
			notificationStore.pushNotification({
				type: notificationStore.ERROR_NOTIFICATION,
				title: 'Assignment Failed',
				message: 'Failed to assign candidates to job'
			});
			// Unblock submit button so user can retry
			this.saving(false);
		}
	}
}
